<template>
  <div>
    <v-row class="content-table">
      <v-col cols="12" md="4" class="d-flex align-center pl-0">
        <v-dialog
          ref="dialog"
          v-model="modalStartDate"
          :return-value.sync="start_date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="mt-0"
              v-model="dateFormatedStart"
              :label="$t('page.profile.start_date')"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
              append-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker
          :locale="$i18n.locale"
            v-model="start_date"
            :max="
              new Date(
                new Date(end_date != '' ? end_date : null) -
                  new Date().getTimezoneOffset() * 60000
              )
                .toISOString()
                .substr(0, 10)
            "
            no-title
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalStartDate = false">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn text color="primary" @click="changeFilterDate">
              {{ $t("ok") }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <span class="mx-2">-</span>
        <v-dialog
          ref="dialogend"
          v-model="modalEndDate"
          :return-value.sync="end_date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="mt-0"
              v-model="dateFormatedEnd"
              :label="$t('page.profile.end_date')"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
              append-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker
          :locale="$i18n.locale"
            :max="
              new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            "
            :min="
              new Date(
                new Date(start_date != '' ? start_date : null) -
                  new Date().getTimezoneOffset() * 60000
              )
                .toISOString()
                .substr(0, 10)
            "
            v-model="end_date"
            no-title
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalEndDate = false">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn text color="primary" @click="changeFilterDate">
              {{ $t("ok") }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12"  md="4" class="d-flex align-center">
        <v-btn
          class="button-box button--outline mr-6"
          outlined
          color="#00A4B3"
          @click="getMonthClick"
          v-if="checkItemMonth == false"
        >
          {{ $t("this_month") }}
        </v-btn>
        <v-btn
          class="button-box button--active mr-6"
          color="#00A4B3"
          dark
          @click="getMonthClick"
          v-if="checkItemMonth == true"
        >
          {{ $t("this_month") }}
        </v-btn>
        <v-btn
          class="button-box button--outline"
          outlined
          color="#00A4B3"
          @click="getYearClick"
          v-if="checkItemYear == false"
        >
          {{ $t("this_year") }}
        </v-btn>
        <v-btn
          class="button-box button--active"
          color="#00A4B3"
          dark
          @click="getYearClick"
          v-if="checkItemYear == true"
        >
          {{ $t("this_year") }}
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" class="d-flex align-center justify-end pr-0">
        <v-text-field
          class="searchField"
          outlined
          dense
          hide-details
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search') + ' ...'"
          single-line
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="mt-3 pa-0">
        <div>
          <v-data-table
            :headers="headerTable"
            :items="revenueList"
            :items-per-page="25"
            :page.sync="pageDataTable"
            class="elevation-1 table-stickoy super-dense"
            @page-count="pageCountDataTable = $event"
            :mobile-breakpoint="0"
            :search="search"
          >
            <template v-slot:item="{ item }">
              <tr class="hd-sticky">
                <td  valign="top" class="pt-2 sticky-c1">{{ item.patient }}</td>
                <td  valign="top" class="pt-2 tb-wide sticky-c2">
                  <a href="javascript:void(0);" @click="openDialogOrder(item)">
                    {{ item.order_number }}
                  </a>
                </td>
                <td  valign="top" class="pt-2">
                  {{ formatDateStandard(item.registration_date) }}
                </td>
                <td  valign="top" class="pt-2 tb-wide">{{ item.patient_id_number }}</td>
                <td  valign="top" class="pt-2">
                  {{ formatDateStandard(item.date_of_birth_format) }}
                </td>
                <td  valign="top" class="pt-2">{{ item[
                              $i18n.locale == "id"
                                ? `patient_age_id`
                                : `patient_age`
                            ] }}</td>
                <td  valign="top" class="pt-2">
                  <p
                    class="list-table" style="margin-bottom: 0px !important;"
                    :class="{
                      'status--unpaid': item.invoice_status == 'unpaid',
                      'status--paid': item.invoice_status == 'paid',
                    }"
                  >
                    <span v-if="item.invoice_status == 'paid'">
                      {{ $t("paid") }}
                    </span>
                    <span v-else>
                      {{ $t("unpaid") }}
                    </span>
                  </p>
                </td>
                <td  valign="top" class="pt-2">-</td>
                <td  valign="top" class="pt-2">
                  <p class="list-table text-right" style="margin-bottom: 0px;">
                    {{ formater(item.amount_paid) }}
                  </p>
                </td>
              </tr>
            </template>
            <template v-slot:[`footer`]>
              <v-divider></v-divider>
              <div class="d-flex align-end justify-end pa-3">
                <p class="mb-0 mr-3" style="font-size : 12px; font-weight:600">Total :</p>
                <p class="mb-0" style="font-size : 12px; font-weight:600">{{formater(totalRevenue)}}</p>
               
              </div>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <DialogOrderDetail
      v-if="dialog_order"
      :item="dataDialogOrder"
      :tampilkan="dialog_order"
      @toggleDialog="is_show => toggleDialogOrder(is_show)"
    />
  </div>
</template>

<script>
import API from "@/service/api_service.js";
import Auth from "@/service/auth_service";
import moment from "moment";
import DialogOrderDetail from "@/components/v2/dialog/dialogOrderDetail.vue";

export default {
  components: {
    DialogOrderDetail,
  },
  data: () => ({
    activeTab: 2,
    checkItemMonth: false,
    checkItemYear: false,
    pageDataTable: 1,
    pageCountDataTable: 2,
    dataPerPage: 25,
    modalStartDate: false,
    modalEndDate: false,
    start_date: "",
    end_date: "",
    start_date_filter: "",
    end_date_filter: "",
    now: "",
    search: "",
    revenueList: [],
    totalPaid: 0,
    totalUnpaid: 0,
    totalRevenue: 0,
    fileNameExcel: "",
    listPerPage: [
      {
        value: -1,
        text: "All",
      },
      {
        value: 10,
        text: "10",
      },
      {
        value: 25,
        text: "25",
      },
      {
        value: 50,
        text: "50",
      },
    ],
    columns: [
      {
        label: "No Referal",
        field: "refer_number",
      },
      {
        label: "No Order",
        field: "order_number",
      },
      {
        label: "ID Pasien",
        field: "patient_id_number",
      },

      {
        label: "Nama Pasien",
        field: "patient",
      },
      {
        label: "Jasa Rujukan",
        field: "revenue",
      },
      {
        label: "Status",
        field: "claimed",
      },
    ],
    headerTable: [],
    listTab: [
      {
        id: 1,
        title: "Referral Report",
      },
      {
        id: 2,
        title: "Fee Report",
      },
    ],
    dialog_order: false,
    dataDialogOrder: {
      order_id: null,
      list: [
        {
          document_information: {
            number_of_report: null,
            medical_record_number: null,
            datetime_observation: null,
            gender: null,
            plant: null,
            primary_doctor: null,
            lab_chief: null,
          },
          customers_information: {
            patient_name: null,
            address: null,
            city: null,
            province: null,
            postal_code: null,
            country: null,
            dob: null,
            patient_age: null,
          },
          product: {
            product_id: null,
            product_code: null,
            product_name: null,
          },
        },
      ],
    },
  }),
  computed: {
    dateFormatedStart() {
      return this.formatDateNow(this.start_date);
    },
    dateFormatedEnd() {
      return this.formatDateNow(this.end_date);
    },
  },
  async mounted() {
    this.headerTable = [
      {
        text: this.$t("page.profile.patient_name"),
        value: "patient",
        align: "center",
        width: "350px",
        class: "sticky-h1",
      },
      {
        text: this.$t("page.profile.order_no"),
        value: "order_number",
        align: "center",
        width: "150px",
        class: "sticky-h2",
      },
      {
        value: "order_date",
        text: this.$t("page.profile.order_date"),
        align: "center",
        width: "160px",
      },
      {
        text: this.$t("page.profile.patient_id"),
        value: "patient_id_number",
        align: "center",
        width: "120px",
      },
     
      {
        text: this.$t("field.birth_date"),
        value: "date_of_birth_format",
        align: "center",
        width: "150px",
      },
      {
        text: this.$t("field.age"),
        value: "patient_age",
        align: "center",
        width: "250px",
      },
      {
        text: this.$t("page.profile.status"),
        value: "claimed",
        align: "center",
        width: "130px",
      },
      {
        text: this.$t("page.profile.result_notes"),
        value: "",
        align: "center",
        width: "150px",
      },
      {
        text: this.$t("page.profile.referral_fee"),
        value: "amount_paid",
        align: "center",
        width: "150px",
      },
    ];
    // this.$store.commit("setLoading", true);
    let getDate = new Date();
    this.fileNameExcel = `revenue_report_${getDate.getFullYear()}${getDate.getMonth()}${getDate.getDate()}${getDate.getHours()}${getDate.getMinutes()}${getDate.getSeconds()}`;

    await API.get(`${process.env.VUE_APP_API_TRUST}referral/get-revenue`, {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Auth.getToken()}`,
    }).then(res => {
      if (res.statusCode == 200) {
        
        this.revenueList = res.results;

        const filterNewUnpaid = res.results.filter(dataNewUnpaid => {
          return dataNewUnpaid.claimed == false;
        });
        filterNewUnpaid.forEach(data => {
          this.totalUnpaid += parseInt(data.amount_paid);
        });
        // this.totalUnpaid = filterNewUnpaid.length;

        const filterNewPaid = res.results.filter(dataNewPaid => {
          return dataNewPaid.claimed == true;
        });
        filterNewPaid.forEach(data => {
          this.totalPaid += parseInt(data.amount_paid);
        });
        // this.totalPaid = filterNewPaid.length;

        this.revenueList.forEach(data => {
          data.amount_paid = data.amount_paid || 0;
          this.totalRevenue += parseInt(data.amount_paid);
        });
      }
    });
    this.now = this.formatDateNow(new Date());
    this.start_date = new Date(
      `${new Date().getFullYear()}-${
        new Date().getMonth() + 1
      }-${new Date().getDate()}`
    )
      .toISOString()
      .substr(0, 10);
    this.end_date = new Date().toISOString().substr(0, 10);
    this.$store.commit("setLoading", false);
  },
  methods: {
    toggleDialogOrder(toggle) {
      this.dialog_order = toggle;
    },
    async openDialogOrder(item) {
      this.dataDialogOrder.order_id = item.order_id;
      this.dataDialogOrder.type_test = item.type;
      this.getOrderDetailPopup();
      this.dialog_order = true;
    },
    async getOrderDetailPopup() {
      let order_id = this.dataDialogOrder.order_id;
    
      try {
        const res = await API.get(
          `${process.env.VUE_APP_API_TRUST}lab-results/get-detail?order_id=` +
            order_id,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );
        this.dataDialogOrder.list = res.results;
      } catch (error) {
        console.log(error);
      }
    },
    currentDataItems() {
      if (this.activeTab == 1) {
        this.$router.push("/doctor/summary-report/referral");
      } else {
        this.$router.push("/doctor/summary-report/fee");
      }
    },
    getDateRange() {
      this.totalPaid = 0;
      this.totalUnpaid = 0;
      this.totalRevenue = 0;
      this.checkItemYear = false;
      this.checkItemMonth = false;

      API.get(`${process.env.VUE_APP_API_TRUST}referral/get-revenue`, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Auth.getToken()}`,
      }).then(res => {
        this.start_date_filter = new Date(this.start_date).getTime();
        this.end_date_filter = new Date(this.end_date).getTime();

        const dateRangeFilter = res.results.filter(dateRangeData => {
          const newDateRangeData = new Date(dateRangeData.registration_date);
          const setDateRange = `${newDateRangeData.getFullYear()}-${(
            "0" +
            (newDateRangeData.getMonth() + 1)
          ).slice(-2)}-${("0" + newDateRangeData.getDate()).slice(-2)}`;
          const dateRangeGetTime = newDateRangeData.getTime();

          if (setDateRange == this.start_date) {
            const setNewDateStart = new Date(this.start_date);
            const setStartFilter = `${setNewDateStart.getFullYear()}-${
              setNewDateStart.getMonth() + 1
            }-${setNewDateStart.getDate() - 1}`;
            const startFilterGetTime = new Date(setStartFilter).getTime();

            return dateRangeGetTime > startFilterGetTime;
          } else if (setDateRange == this.end_date) {
            const setDateFilterRange = `${newDateRangeData.getFullYear()}-${
              newDateRangeData.getMonth() + 1
            }-${newDateRangeData.getDate() - 1}`;
            const DateNewDateFilter = new Date(setDateFilterRange).getTime();
            const endFilterGetTime = new Date(this.end_date).getTime();

            return DateNewDateFilter < endFilterGetTime;
          } else {
            return (
              dateRangeGetTime > this.start_date_filter &&
              dateRangeGetTime < this.end_date_filter
            );
          }
        });
        this.revenueList = dateRangeFilter;

        const filterNewUnpaid = this.revenueList.filter(dataNewUnpaid => {
          return dataNewUnpaid.claimed == false;
        });
        filterNewUnpaid.forEach(data => {
          this.totalUnpaid += parseInt(data.amount_paid);
        });
        // this.totalUnpaid = filterNewUnpaid.length;

        const filterNewPaid = this.revenueList.filter(dataNewPaid => {
          return dataNewPaid.claimed == true;
        });
        filterNewPaid.forEach(data => {
          this.totalPaid += parseInt(data.amount_paid);
        });
        // this.totalPaid = filterNewPaid.length;

        this.revenueList.forEach(data => {
          data.amount_paid = data.amount_paid || 0;
          this.totalRevenue += parseInt(data.amount_paid);
        });
      });
    },
    formatDateNow(param) {
      if (!param) return null;
      const date = new Date(param);
      // return `${("0" + date.getDate()).slice(-2)}-${(
      //     "0" +
      //     (date.getMonth() + 1)
      // ).slice(-2)}-${date.getFullYear()}`;
      return moment(date).locale(this.$i18n.locale).format("DD-MMM-YYYY").toUpperCase();
    },
    changeFilterDate() {
      this.$refs.dialog.save(this.start_date);
      this.$refs.dialogend.save(this.end_date);
      this.getDateRange();
      this.modalStartDate = false;
      this.modalEndDate = false;
    },
    formater(value) {
      // let val = (value / 1).toFixed(0).replace(".", ",");
      // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      let angka = parseInt(value) || 0;
      let nilai = angka.toLocaleString("en-US", { minimumFractionDigits: 2 });
      return nilai;
    },
    formatDateStandard(value) {
      return moment(value).locale(this.$i18n.locale).format("DD-MMM-YYYY").toUpperCase();
    },

    formatDateStandardWithTime(value) {
      return moment(value).format("DD-MMM-YYYY HH:mm:ss").toUpperCase();
    },

    getYearClick() {
      this.totalPaid = 0;
      this.totalUnpaid = 0;
      this.totalRevenue = 0;
      const dateNow = new Date();
      const setYearNow = `${dateNow.getFullYear()}`;

      API.get(`${process.env.VUE_APP_API_TRUST}referral/get-revenue`, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Auth.getToken()}`,
      }).then(res => {
        const yearFilter = res.results.filter(setDataYear => {
          const newYearFilterData = new Date(setDataYear.registration_date);
          const setDateFormat = `${(
            "0" +
            (newYearFilterData.getMonth() + 1)
          ).slice(-2)}/${("0" + newYearFilterData.getDate()).slice(
            -2
          )}/${newYearFilterData.getFullYear()}`;
          const yearSlice = +setDateFormat.slice(-4);
          return setYearNow == yearSlice;
        });

        this.revenueList = yearFilter;
        this.checkItemYear = true;
        this.checkItemMonth = false;
        const filterNewUnpaid = this.revenueList.filter(dataNewUnpaid => {
          return dataNewUnpaid.claimed == false;
        });
        filterNewUnpaid.forEach(data => {
          this.totalUnpaid += parseInt(data.amount_paid);
        });
        // this.totalUnpaid = filterNewUnpaid.length;

        const filterNewPaid = this.revenueList.filter(dataNewPaid => {
          return dataNewPaid.claimed == true;
        });
        filterNewPaid.forEach(data => {
          this.totalPaid += parseInt(data.amount_paid);
        });
        // this.totalPaid = filterNewPaid.length;

        this.revenueList.forEach(data => {
          data.amount_paid = data.amount_paid || 0;
          this.totalRevenue += parseInt(data.amount_paid);
        });
      });
    },
    getMonthClick() {
      this.totalPaid = 0;
      this.totalUnpaid = 0;
      this.totalRevenue = 0;
      const dateNow = new Date();
      const setMonthYearNow = `${("0" + (dateNow.getMonth() + 1)).slice(
        -2
      )}-${dateNow.getFullYear()}`;

      API.get(`${process.env.VUE_APP_API_TRUST}referral/get-revenue`, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Auth.getToken()}`,
      }).then(res => {
        const monthYearFilter = res.results.filter(setDataMonthYear => {
          const newMonthYearFilterData = new Date(
            setDataMonthYear.registration_date
          );
          const setMonthYearFormat = `${(
            "0" +
            (newMonthYearFilterData.getMonth() + 1)
          ).slice(-2)}-${newMonthYearFilterData.getFullYear()}`;

          return setMonthYearNow == setMonthYearFormat;
        });

        this.revenueList = monthYearFilter;
        this.checkItemYear = false;
        this.checkItemMonth = true;

        const filterNewUnpaid = this.revenueList.filter(dataNewUnpaid => {
          return dataNewUnpaid.claimed == false;
        });
        filterNewUnpaid.forEach(data => {
          this.totalUnpaid += parseInt(data.amount_paid);
        });
        // this.totalUnpaid = filterNewUnpaid.length;

        const filterNewPaid = this.revenueList.filter(dataNewPaid => {
          return dataNewPaid.claimed == true;
        });
        filterNewPaid.forEach(data => {
          this.totalPaid += parseInt(data.amount_paid);
        });
        // this.totalPaid = filterNewPaid.length;

        this.revenueList.forEach(data => {
          data.amount_paid = data.amount_paid || 0;
          this.totalRevenue += parseInt(data.amount_paid);
        });
      });
    },
    reloadPage() {
      window.location.href = `/dashboard/summary-report/fee`;
    },
  },
};
</script>

<style>
  @media screen and (min-width: 1023px) {
  .sticky-c1{
    position: sticky!important;
    position: -webkit-sticky!important;
    left: 0;
    z-index: 2;
    background: #fff;
  }
  .sticky-c2{
    position: sticky!important;
    position: -webkit-sticky!important;
    left: 350px;
    z-index: 2;
    background: #fff;
  }
  .sticky-h1{
    position: sticky!important;
    position: -webkit-sticky!important;
    left: 0;
    z-index: 2;
    background: #ddd;
  }
  .sticky-h2{
    position: sticky!important;
    position: -webkit-sticky!important;
    left: 350px;
    z-index: 2;
    background: #ddd;
  }
}
 /* Hide scrollbar for Chrome, Safari and Opera */
.table-stickoy .v-data-table__wrapper::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.table-stickoy .v-data-table__wrapper {
  -ms-overflow-style: none;   
  scrollbar-width: none;   
}
.super-dense > .v-data-table__wrapper > table > tbody > tr > td, 
.super-dense > .v-data-table__wrapper > table > tbody > tr > th, 
.super-dense > .v-data-table__wrapper > table > thead > tr > td, 
.super-dense > .v-data-table__wrapper > table > thead > tr > th, 
.super-dense > .v-data-table__wrapper > table > tfoot > tr > td{
  height:35px !important;
}
.table-stickoy .v-data-table__wrapper {
    overflow-x: auto;
    overflow-y: auto;
    height: 300px;
  }
  .table-stickoy thead {
    position: sticky;
    inset-block-start: 0;
    top: 0;
    background: #ddd !important;
    font-weight: bold;
    color: #000 !important;
  }
  
  /* @media (min-width: 600px) {
  .table-stickoy .v-data-table__wrapper {
    overflow: unset;
  }
  .table-stickoy thead {
    position: sticky;
    inset-block-start: 0;
    top: 0;
    background: #eeeeee !important;
    font-weight: bold;
    color: #000 !important;
  }
}
@media (max-width: 599px) {
  .table-stickoy .v-data-table__wrapper {
    overflow-x: auto;
    overflow-y: auto;
    height: 400px;
  }
  .table-stickoy thead tr {
    border-bottom: 0 !important;
    position: sticky;
    top: 0;
    z-index: 2;
  }
} */
</style>
<style lang="scss" scoped>
@import "@/assets/css/custom.scss";
.hd-sticky:hover{
    .sticky-c1{
      background: #eee !important;
    }
    .sticky-c2{
      background: #eee !important;
    }
    .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:first-child{
      background: #eee !important;
    }
  }

.searchField {
  max-width: 500px;
}
.button--active {
  background: $main_3;
  color: white;
}
.button--outline {
  color: $main_3;
  border: 1px solid $main_3;
  background: white;
}
.button-box {
  box-sizing: border-box;
  border-radius: 10px;
  padding: 8px 16px;
  outline: none;
  text-transform: capitalize;
}
.card--result {
  background: $gray_3;
  padding: 18px;
  border-radius: 16px;
  width: 100%;
  // max-width: 300px;
  color: $gray_2;
  h4 {
    color: $gray_1;
    font-size: 20px;
  }
  p {
    margin: 0;
  }
  .card--result__item {
    padding: 6px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $gray_2;
    &:nth-last-child(1) {
      border: none;
    }
  }
}

.status--paid {
  color: $green_1;
  font-weight: 600;
}
.status--unpaid {
  color: $red_1;
  font-weight: 600;
}
.tabs {
  background: #e5e5e5 !important;
}
.content-table {
  padding: 15px;
  @media screen and (max-width: 960px) {
    padding: 5px 18px 18px 18px;
  }
}
.total-fee {
  padding: 5px 18px 18px 18px;
}

.v-input {
  font-size: 12px !important;
}

@media screen and (max-width: 480px) {
  .content-table {
    padding: 0px !important;
  }
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 12px;
  vertical-align: baseline;
  padding-top: 6px;
  padding-bottom: 6px;
  height: 25px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 35px !important;
}
</style>
